



























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { Analysis, FarmAnalysis } from "@/api/analyses/types";
import AnalysesViewer from "../analysis-viewer/AnalysesViewer.vue";
import AnalysisDelete from '@/components/analyses-delete/AnalysisDelete.vue';
import { RawLocation } from "vue-router";

@Component({
  name: "AnalysesTabs",
  components: {
    AnalysesViewer,
    AgroIcons,
    AnalysisDelete,
  },
})
export default class AnalysesTabs extends Vue {
  @Prop({ type: String, default: "" }) private ownerName!: string;
  @Prop({ type: String, default: "" }) private farmName!: string;
  @Prop({ type: String, default: "" }) private source?: string;
  @Prop({ type: Array, required: true })
  private farmAnalysisList!: FarmAnalysis[];

  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  private mountBackLink(): RawLocation {
    if (this.source == 'farms-home') {
      return { name: 'farms-home' };
    } else {
      return { name: 'farms', params: { ownerUuid: this.analysis.ownerUuid }};
    }
  }

  private goBack() {
    const backlink = this.mountBackLink();
    this.$router.replace(backlink);
  }

  get sortedYears() {
    return this.farmAnalysisList.sort((first, last) =>
      first.analysisYear > last.analysisYear ? -1 : 1
    );
  }

  get farmRegion() {
    if (this.analysis) {
      return [
        this.analysis.city,
        this.analysis.microRegion,
        this.analysis.state,
      ]
        .filter((v) => !!v)
        .join(" / ");
    }
    return "";
  }

  private tabActive: number | null = null;
  private hasSummerByYear: { [year: number]: boolean } = {};

  private mounted() {
    this.setTabActive(this.sortedYears[0].analysisYear);
  }

  private setTabActive(clickedItem: number) {
    this.tabActive = clickedItem;
    return this.tabActive;
  }

  private onHasSummerUpdate(payload: { year: number; hasSummer: boolean }) {
    this.$set(this.hasSummerByYear, payload.year, payload.hasSummer);
  }

  get currentHasSummer(): boolean {
    return this.tabActive != null && !!this.hasSummerByYear[this.tabActive];
  }

  get showHarvestSeasonSelect(): boolean {
    return this.analysis.unified
      || (this.currentHasSummer && this.analysis.harvestSeason === 'WINTER');
  }

  get harvestSeasonQuery(): string {
    const value = this.$route.query.harvestSeason;
    if (value === 'SUMMER' || value === 'WINTER') return value;
    return this.analysis.harvestSeason;
  }

  set harvestSeasonQuery(value: string) {
    if (this.$route.query.harvestSeason === value) return;
    this.$router.replace({
      query: { ...this.$route.query, harvestSeason: value },
    }).catch(() => {});
  }

  private generateYearLabel(analysisYear: number) {
    const analysisYearBefore = analysisYear - 1;
    const analysisYearString = `${analysisYear}`;

    return `${analysisYearBefore}/${analysisYearString.substring(
      analysisYearString.length - 2
    )}`;
  }
}
